<template>
    <div>
        <form  >
            <div class="layout-form">
                <div :class="['form-group', 'mb-50', {error : validation.firstError('subject')}]">
                        <div class="controls">
                            <label>{{ $t("message.subject") }}</label>
                            <input type="text" class="form-control"  v-model="subject"/>
                            <div class="help-block">{{ validation.firstError('subject') }}</div>
                        </div> 
                </div> 
                <div :class="['form-group', 'mb-50', {error : validation.firstError('message')}]">
                        <div class="controls">
                            <label>{{ $t("message.message") }}</label>
                            <textarea class="form-control" rows="5" v-model="message"/>
                            <div class="help-block">{{ validation.firstError('message') }}</div>
                        </div> 
                </div> 
                

                <div class="form-group">
                    <div class="actions">
                        <button type="button" class="btn btn-primary" @click.prevent="send">{{ $t("message.send") }}</button>
                    </div>
                </div>
            </div>
        </form>
        </div>

</template>
<script>
    import globalSettings from '@/config.js'
    import Validator from '@/formValidator';
    import {error_setter} from '@/formValidator'
    import axios from '@/axios'
            export default{
                name: 'feedback_form',
                data() {
                    return{
                    subject:null,
                    message:null,
                    
                    }
                },
                mixins:[error_setter],
                validators: {
                    'subject': function (value) {
                        return Validator.value(value).required().minLength(8);
                    },
                    'message': function (value) {
                        return Validator.value(value).required().minLength(8);
                    },
                    
                },
                methods: {
                    
                     send:  function () {
                        const url = globalSettings.api_url + 'user/feedback';
                        const return_data = {
                            subject: this.subject,
                            message: this.message,
                        }
                        this.$validate().then(valid => {
                        if (valid) {
                            return axios.post(url, return_data)
                            .then((response)=>{
                                if(response.data == 'ok'){
                                    this.$store.dispatch('set_alert',{type:'success', text:this.$t('message.message_sended')})
                                    this.$emit('action_success')
                                    this.reset_form()
                                    
                                }else{
                                    this.add_external_errors(response.data.errors)
                                }
                            })
                            .catch((error)=>{
                               console.log(error)
                            })
                        }
                    });
                        
                    },
                    reset_form: function () {
                        this.subject= null
                        this.message= null
                        this.validation.reset()

                    },
                    
                
                }
            
            }

</script>

                          